export const dataSlides = [
    {
        id: 1,
        image: "https://images.unsplash.com/photo-1602343168117-bb8ffe3e2e9f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dmlsbGF8ZW58MHwxfDB8fHww&auto=format&fit=crop&w=500&q=60"
    },
    {
        id: 2,
        image: "https://images.unsplash.com/photo-1597211833712-5e41faa202ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8dmlsbGF8ZW58MHwxfDB8fHww&auto=format&fit=crop&w=500&q=60"
    },
    {
        id: 3,
        image: "https://images.unsplash.com/photo-1594479125841-ff7800c6afcc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8dmlsbGF8ZW58MHwxfDB8fHww&auto=format&fit=crop&w=500&q=60"
    },
]